const state = {
    data: []
}

const mutations = {
    storeReviews (state, payload) {
        state.data = payload
    },
    storeReview (state, payload) {
        state.data.unshift(payload)
    },
    updateReview (state, payload) {
        let review = state.data.find(item => item.id === payload.id)

        review = payload
    },
    changeReviewState (state, payload) {
        const review = state.data.find(item => item.id === payload.id)

        review.status = payload.status
    },
    deleteReview (state, payload) {
        state.data = state.data.filter(item => item.id !== payload.id)
    }
}

const actions = {}

const getters = {
    getReviews: state => state.data
}

export default {
    state,
    mutations,
    actions,
    getters
}
